import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import VuePlyr from "vue-plyr";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import i18n from "./i18n";
import VueScrollTo from "vue-scrollto";
import axios from "axios";
import wait from './wait';
import VueScrollactive from 'vue-scrollactive';

axios.interceptors.response.use(response => {
  return response;
}, async error => {
  /*
   * If we get 401 response code, JWT token is expired and we needed to fetch new token with a refresh token which is saved in browser cookies.
   */
  if (error.response.status === 401) {
    /*
     * We have to set config.withCredentials = true in order to send browser cookies within refresh-token request to FixitCoreApi which is on a different domain.
     * This setting can be set globally on every axios request - if needed.
     */
    let authResponse = await axios.post(`${CONFIG.fixitCoreApiUrl}/api/v2/Authorization/refresh-token`, null, {withCredentials: true})
    /*
    * If refresh token is expired redirect to login page
    */
    if (authResponse.status !== 200)
      window.location.href = '/Account/Login?ReturnUrl=' + window.location.pathname
    else {
      /*
      * Set new JWT token to Authorization headers in axios global config and currently intercepted request config, and execute intercepted request again.
      */
      error.config.headers.Authorization = axios.defaults.headers.common["Authorization"] = `Bearer ${authResponse.data.jwtToken}`
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }
  }
  return error;
});

Vue.config.productionTip = false;
Vue.use(VuePlyr);
Vue.use(VueScrollTo);
Vue.use(VueScrollactive);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  wait,
  render: h => h(App)
}).$mount("#app");
